document.addEventListener('click', (event) => {
  const localeButton = event.target.closest('button[name="locale_code"]');
  if (localeButton) {
    event.preventDefault();
    setKayanLocale(localeButton.value);
    return;
  }

  const kayanMenuButton = event.target.closest('.kayan-menu[aria-controls="KayanMenuModal"]');
  if (kayanMenuButton) {
    event.preventDefault();
    const modal = document.getElementById('KayanMenuModal');
    if (modal) {
      modal.hidden = false;
      kayanMenuButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('kayan-menu-open');
      modal.querySelector('.kayan-menu-product')?.focus();
    }
    return;
  }

  const kayanMenuClose = event.target.closest('.kayan-menu-close, .kayan-menu-modal__backdrop');
  if (kayanMenuClose) {
    event.preventDefault();
    closeKayanMenu();
    return;
  }

  const kayanVariantOption = event.target.closest('.kayan-format-option[data-variant-id]');
  if (kayanVariantOption) {
    event.preventDefault();
    selectKayanVariant(kayanVariantOption);
    return;
  }

  const thumb = event.target.closest('.casa-mobile-thumbs button');
  if (thumb) {
    const index = Array.from(thumb.parentElement.children).indexOf(thumb);
    const gallery = document.querySelector('.casa-media-grid');
    const card = gallery?.children[index];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  const kayanThumb = event.target.closest('.kayan-product-thumbs button');
  if (kayanThumb) {
    const index = Array.from(kayanThumb.parentElement.children).indexOf(kayanThumb);
    const gallery = document.querySelector('.kayan-product-gallery');
    const card = gallery?.children[index];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
});

document.addEventListener('submit', (event) => {
  if (event.target.matches('.atelier-newsletter, .kayan-newsletter')) {
    event.preventDefault();
  }

  const kayanBuyForm = event.target.closest('.kayan-buy-form');
  if (kayanBuyForm) {
    event.preventDefault();
    addKayanProductToCart(kayanBuyForm);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeKayanMenu();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const browserLocale = document.documentElement.lang?.slice(0, 2);
  const savedLocale = localStorage.getItem('kayanLocale') || browserLocale || 'en';
  setKayanLocale(savedLocale, { persist: false });
});

function closeKayanMenu() {
  const modal = document.getElementById('KayanMenuModal');
  if (!modal || modal.hidden) {
    return;
  }

  modal.hidden = true;
  document.body.classList.remove('kayan-menu-open');
  const menuButton = document.querySelector('.kayan-menu[aria-controls="KayanMenuModal"]');
  menuButton?.setAttribute('aria-expanded', 'false');
  menuButton?.focus();
}

async function addKayanProductToCart(form) {
  const button = form.querySelector('.kayan-main-atc');
  if (button?.disabled) {
    return;
  }

  const originalLabel = button?.querySelector('span:last-child')?.textContent;
  button?.setAttribute('disabled', 'disabled');
  button?.classList.add('is-loading');
  const label = button?.querySelector('span:last-child');
  if (label) {
    label.textContent = document.documentElement.lang?.startsWith('en') ? 'ADDING...' : 'AJOUT...';
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    window.location.href = '/cart';
  } catch (error) {
    if (label && originalLabel) {
      label.textContent = originalLabel;
    }
    button?.removeAttribute('disabled');
    button?.classList.remove('is-loading');
    form.submit();
  }
}

function setKayanLocale(locale, options = {}) {
  const nextLocale = locale === 'fr' ? 'fr' : 'en';
  if (options.persist !== false) {
    localStorage.setItem('kayanLocale', nextLocale);
  }

  document.documentElement.lang = nextLocale;
  document.querySelectorAll('button[name="locale_code"]').forEach((button) => {
    button.classList.toggle('is-active', button.value === nextLocale);
  });

  applyKayanTranslations(nextLocale);
}

function applyKayanTranslations(locale) {
  const isFr = locale === 'fr';
  const productPage = document.querySelector('.kayan-product-page');
  const homePage = document.querySelector('.kayan-home');
  const cartPage = document.querySelector('.kayan-cart-page');

  if (productPage) {
    const isSoleil = productPage.classList.contains('profile-soleil');
    translateProductPage(isFr, isSoleil);
  }

  if (homePage) {
    translateHomePage(isFr);
  }

  if (cartPage) {
    translateCartPage(isFr);
  }

  translateFooter(isFr);
}

function setText(selector, text, root = document) {
  const element = root.querySelector(selector);
  if (element && text) {
    element.textContent = text;
  }
}

function setAllText(selector, texts, root = document) {
  root.querySelectorAll(selector).forEach((element, index) => {
    if (texts[index]) {
      element.textContent = texts[index];
    }
  });
}

function translateProductPage(isFr, isSoleil) {
  const product = isSoleil
    ? {
        kind: ['BODY MIST - 80 ML', 'BRUME CORPS - 80 ML'],
        tagline: [
          'The twilight mist: sea salt, grapefruit, ambrette and sandalwood on skin that still holds the warmth of the day.',
          'La brume du crépuscule: sel marin, pamplemousse, ambrette et santal sur une peau encore chaude.'
        ],
        badge: ['80 ML - LAUNCH STOCK: 600 UNITS', '80 ML - STOCK DE LANCEMENT: 600 UNITÉS'],
        cta: ['ADD THE MIST', 'AJOUTER LA BRUME'],
        ritual: ['CHOOSE YOUR RITUAL', 'CHOISIR VOTRE RITUEL'],
        storyTitle: ['An evening the skin remembers', 'Une soirée que la peau retient'],
        story: [
          'The sun has just surrendered to the horizon. The air still holds the warmth of the day, the sea murmurs, and the trail becomes more intimate as night arrives. Soleil de Kayan is a luminous, salty and musky mist designed to revive the skin without ever weighing it down.',
          "Le soleil vient de se rendre à l'horizon. L'air garde encore la chaleur du jour, la mer murmure, et le sillage devient plus intime à mesure que la nuit arrive. Soleil de Kayan est une brume lumineuse, salée et musquée, pensée pour raviver la peau sans jamais l'alourdir."
        ],
        notes: ['Top', 'Heart', 'Base'],
        notesFr: ['Tête', 'Coeur', 'Fond'],
        noteLines: ['Sea salt<br>Sage<br>Grapefruit', 'Ambrette<br>Marine algae', 'Sandalwood<br>Musk<br>Vanilla'],
        noteLinesFr: ['Sel marin<br>Sauge<br>Pamplemousse', 'Ambrette<br>Algue marine', 'Bois de santal<br>Musc<br>Vanille'],
        upsellTitle: ['Complete with Premier Souffle', 'Compléter avec Premier Souffle'],
        upsellText: [
          'Pair it with Premier Souffle to anchor the trail: the mist brings the light, the extrait sets the depth.',
          "Associez-la à Premier Souffle pour ancrer le sillage: la brume apporte la lumière, l'extrait pose la profondeur."
        ],
        upsellLink: ['View Premier Souffle', 'Voir Premier Souffle'],
        accordionBodies: [
          [
            'An airier mist, ideal for reviving the KAYAN sensation after a shower, before going out or during the day.',
            'Sea salt / Sage / Grapefruit - Ambrette / Marine algae - Sandalwood / Musk / Vanilla',
            'Ready to connect to the final store policies. The wording can be refined once Nadi confirms the exact terms.'
          ],
          [
            'Une brume plus aérienne, idéale pour raviver la sensation KAYAN après la douche, avant une sortie ou dans la journée.',
            'Sel marin / Sauge / Pamplemousse - Ambrette / Algue marine - Bois de santal / Musc / Vanille',
            'Section prête à connecter aux conditions finales de la boutique. Le wording pourra être ajusté selon la politique exacte de Nadi.'
          ]
        ],
        labTitle: ['Every note has its place in the trail.', 'Chaque note a sa place dans le sillage.'],
        labText: [
          'A moving reading of the formula: the opening catches attention, the heart gives texture, the base leaves the memory.',
          "Une lecture vivante de la formule: la tête capte l'attention, le coeur donne la matière, le fond laisse la mémoire."
        ],
        ingredientHeading: ['The ingredients of twilight.', 'Les ingrédients du crépuscule.'],
        ingredientText: [
          'An airier trail: sea salt, sage and grapefruit open the light, then ambrette, marine algae, sandalwood, musk and vanilla extend the skin.',
          "Un sillage plus aérien: sel marin, sauge et pamplemousse ouvrent la lumière, puis l'ambrette, l'algue marine, le santal, le musc et la vanille prolongent la peau."
        ],
        ingredientNames: [
          ['Sea salt', 'Sage', 'Grapefruit', 'Ambrette', 'Marine algae', 'Sandalwood', 'Musk', 'Vanilla'],
          ['Sel marin', 'Sauge', 'Pamplemousse', 'Ambrette', 'Algue marine', 'Bois de santal', 'Musc', 'Vanille']
        ],
        ingredientStages: [
          ['Top', 'Top', 'Top', 'Heart', 'Heart', 'Base', 'Base', 'Base'],
          ['Tête', 'Tête', 'Tête', 'Coeur', 'Coeur', 'Fond', 'Fond', 'Fond']
        ],
        flatNotes: [
          ['Sea salt', 'Sage', 'Grapefruit', 'Ambrette', 'Marine algae', 'Sandalwood', 'Musk', 'Vanilla'],
          ['Sel marin', 'Sauge', 'Pamplemousse', 'Ambrette', 'Algue marine', 'Bois de santal', 'Musc', 'Vanille']
        ]
      }
    : {
        kind: ['EXTRAIT DE PARFUM - 50 ML / 100 ML', 'EXTRAIT DE PARFUM - 50 ML / 100 ML'],
        tagline: [
          'Omani Hojari incense, fresh ginger, solar honey, tonka, vanilla and white musks. A warm, magnetic skin signature.',
          "Encens Hojari d'Oman, gingembre frais, miel solaire, tonka, vanille et muscs blancs. Une signature de peau, chaude et magnétique."
        ],
        badge: ['50 ML / 100 ML - AVAILABLE STOCK', '50 ML / 100 ML - STOCK DISPONIBLE'],
        cta: ['ADD THE EXTRAIT', "AJOUTER L'EXTRAIT"],
        ritual: ['CHOOSE YOUR RITUAL', 'CHOISIR VOTRE RITUEL'],
        storyTitle: ['The mystic glow', "L'éclat mystique"],
        story: [
          'A sensory architecture built on contrast: the cool verticality of incense meets the sensual roundness of honeyed and amber notes. Premier Souffle evokes an Oriental morning: the fire of ginger, the sacred clarity of incense, then the golden warmth of honey, tonka and vanilla.',
          "Une architecture sensorielle qui joue sur le contraste entre la verticalité froide de l'encens et la rondeur charnelle des notes miellées et ambrées. Premier Souffle évoque un matin d'Orient: le feu du gingembre, la clarté sacrée de l'encens, puis la chaleur dorée du miel, de la tonka et de la vanille."
        ],
        notes: ['Top', 'Heart', 'Base'],
        notesFr: ['Tête', 'Coeur', 'Fond'],
        noteLines: ['Fresh ginger<br>Omani Hojari incense', 'Solar honey', 'Tonka bean<br>Vanilla<br>White musks'],
        noteLinesFr: ["Gingembre frais<br>Encens Hojari d'Oman", 'Miel solaire', 'Fève tonka<br>Vanille<br>Muscs blancs'],
        upsellTitle: ['Complete with Soleil de Kayan', 'Compléter avec Soleil de Kayan'],
        upsellText: [
          'Complete it with Soleil de Kayan for a lighter, solar and marine touch throughout the day.',
          'Complétez avec Soleil de Kayan pour une retouche plus légère, solaire et marine au cours de la journée.'
        ],
        upsellLink: ['View Soleil de Kayan', 'Voir Soleil de Kayan'],
        accordionBodies: [
          [
            'An extrait built for long-lasting presence, with white musks that lock amber warmth onto the skin.',
            'Fresh ginger / Omani Hojari incense - Solar honey - Tonka bean / Vanilla / White musks',
            'Ready to connect to the final store policies. The wording can be refined once Nadi confirms the exact terms.'
          ],
          [
            'Un extrait construit pour une présence longue durée, avec des muscs blancs qui fixent la chaleur ambrée sur la peau.',
            "Gingembre frais / Encens Hojari d'Oman - Miel solaire - Fève tonka / Vanille / Muscs blancs",
            'Section prête à connecter aux conditions finales de la boutique. Le wording pourra être ajusté selon la politique exacte de Nadi.'
          ]
        ],
        labTitle: ['Every note has its place in the trail.', 'Chaque note a sa place dans le sillage.'],
        labText: [
          'A moving reading of the formula: the opening catches attention, the heart gives texture, the base leaves the memory.',
          "Une lecture vivante de la formule: la tête capte l'attention, le coeur donne la matière, le fond laisse la mémoire."
        ],
        ingredientHeading: ['The ingredients behind the trail.', 'Les ingrédients derrière le sillage.'],
        ingredientText: [
          'From the bright opening to the warm signature on skin, each note appears like a fragment of the Maison KAYAN ritual.',
          "De l'ouverture lumineuse à la signature chaude sur la peau, chaque note apparaît comme un fragment du rituel Maison KAYAN."
        ],
        ingredientNames: [
          ['Fresh ginger', 'Omani Hojari incense', 'Solar honey', 'Tonka bean', 'Vanilla', 'White musks'],
          ['Gingembre frais', "Encens Hojari d'Oman", 'Miel solaire', 'Fève tonka', 'Vanille', 'Muscs blancs']
        ],
        ingredientStages: [
          ['Top', 'Top', 'Heart', 'Base', 'Base', 'Base'],
          ['Tête', 'Tête', 'Coeur', 'Fond', 'Fond', 'Fond']
        ],
        flatNotes: [
          ['Fresh ginger', 'Omani Hojari incense', 'Solar honey', 'Tonka bean', 'Vanilla', 'White musks'],
          ['Gingembre frais', "Encens Hojari d'Oman", 'Miel solaire', 'Fève tonka', 'Vanille', 'Muscs blancs']
        ]
      };

  const index = isFr ? 1 : 0;
  setText('.kayan-product-eyebrow', product.kind[index]);
  setText('.kayan-product-tagline', product.tagline[index]);
  setText('.kayan-stock-badge', product.badge[index]);
  setText('.kayan-main-atc span:last-child', product.cta[index]);
  setText('.kayan-format-box > p', product.ritual[index]);
  setText('.kayan-product-copy h2', product.storyTitle[index]);
  setText('.kayan-product-copy p', product.story[index]);
  setAllText('.kayan-notes h3', isFr ? product.notesFr : product.notes);
  document.querySelectorAll('.kayan-notes p').forEach((element, noteIndex) => {
    element.innerHTML = (isFr ? product.noteLinesFr : product.noteLines)[noteIndex] || element.innerHTML;
  });
  setText('.kayan-ritual-card h2', product.upsellTitle[index]);
  setText('.kayan-ritual-card p', product.upsellText[index]);
  setText('.kayan-ritual-card a', product.upsellLink[index]);
  setAllText('.kayan-accordion summary', isFr ? ['Tenue et sillage', 'Pyramide olfactive complète', 'Livraison et retours'] : ['Longevity and trail', 'Full olfactive pyramid', 'Shipping and returns']);
  setAllText('.kayan-accordion p', product.accordionBodies[index]);
  setText('.kayan-olfactive-lab__intro .kayan-kicker', isFr ? 'PYRAMIDE OLFACTIVE' : 'OLFACTIVE PYRAMID');
  setText('.kayan-olfactive-lab__intro h2', product.labTitle[index]);
  setText('.kayan-olfactive-lab__intro p', product.labText[index]);
  setAllText('.kayan-olfactive-cards h3', isFr ? product.notesFr : product.notes);
  setAllText('.kayan-olfactive-cards p', (isFr ? product.noteLinesFr : product.noteLines).map((line) => line.replaceAll('<br>', ' · ')));
  setAllText('.kayan-floating-notes span', product.flatNotes[index]);
  setText('.kayan-ingredient-heading .kayan-kicker', isFr ? 'PYRAMIDE OLFACTIVE' : 'OLFACTIVE PYRAMID');
  setText('.kayan-ingredient-heading h2', product.ingredientHeading?.[index]);
  setText('.kayan-ingredient-heading p', product.ingredientText?.[index]);
  if (product.ingredientNames) {
    setAllText('.kayan-ingredient-card strong', [...product.ingredientNames[index], ...product.ingredientNames[index]]);
    setAllText('.kayan-ingredient-card span', [...product.ingredientStages[index], ...product.ingredientStages[index]]);
  }
  setText('.kayan-testimonial h2', isFr ? 'Un parfum qui ne cherche pas à plaire à tout le monde. Il signe une présence, puis reste dans la mémoire.' : 'A fragrance that does not try to please everyone. It signs a presence, then stays in memory.');
  setText('.kayan-marquee p', isFr ? 'OMAN-PARIS • SILLAGE MÉMORIEL • OR CHAMPAGNE • ÉLÉGANCE OBSCURE •' : 'OMAN-PARIS • MEMORABLE TRAIL • CHAMPAGNE GOLD • DARK ELEGANCE •');
  setText('.kayan-excellence h2', isFr ? "L'essence du caractère." : 'The essence of character.');
  setText('.kayan-excellence p', isFr ? 'Des compositions qui racontent une femme: enracinée, moderne, calme, impossible à oublier.' : 'Compositions that tell the story of a woman: rooted, modern, calm, impossible to forget.');
  setText('.kayan-excellence a', isFr ? 'Découvrir la collection' : 'Discover the collection');
}

function translateFooter(isFr) {
  document.querySelectorAll('.kayan-footer').forEach((footer) => {
    const description = footer.querySelector('.kayan-footer-description');
    if (description) {
      description.innerHTML = isFr
        ? "<strong>KAYAN</strong> incarne l'union subtile d'un héritage oriental et d'une élégance contemporaine.<br>Chaque création est pensée comme une signature invisible, une empreinte unique, à la fois puissante et délicate.<br>Plus qu'un parfum, KAYAN est une vision: celle d'un caractère affirmé enveloppé de douceur."
        : '<strong>KAYAN</strong> embodies the subtle union of oriental heritage and contemporary elegance.<br>Each creation is designed as an invisible signature, a unique imprint, both powerful and delicate.<br>More than a fragrance, KAYAN is a vision: one of a defined character wrapped in softness.';
    }

    setText('nav[aria-label="Discover"] h2', isFr ? 'Découvrir' : 'Discover', footer);
    setText('nav[aria-label="Support"] h2', isFr ? 'Assistance' : 'Support', footer);
    setText('.kayan-footer-contact h2', isFr ? 'Contact' : 'Get in Touch', footer);
    setAllText('nav[aria-label="Support"] a', isFr ? ['boîte mail contact', 'Politique de remboursement', 'Politique de confidentialité', 'Politique de remboursement'] : ['contact mail box', 'Refund policy', 'Privacy policy', 'Refund policy'], footer);
  });
}

function selectKayanVariant(option) {
  const form = document.querySelector('.kayan-buy-form');
  const variantInput = form?.querySelector('input[name="id"]');
  const atcButton = form?.querySelector('.kayan-main-atc');
  const priceLabel = atcButton?.querySelector('[data-kayan-atc-price]');
  const actionLabel = atcButton?.querySelector('[data-kayan-atc-label]');
  const isAvailable = option.dataset.variantAvailable === 'true';

  if (variantInput) {
    variantInput.value = option.dataset.variantId;
  }

  if (priceLabel && option.dataset.variantPrice) {
    priceLabel.textContent = option.dataset.variantPrice;
  }

  document.querySelectorAll('.kayan-format-option[data-variant-id]').forEach((button) => {
    button.classList.toggle('is-active', button === option);
  });

  if (atcButton) {
    atcButton.toggleAttribute('disabled', !isAvailable);
  }

  if (actionLabel) {
    const isFr = document.documentElement.lang === 'fr';
    actionLabel.textContent = isAvailable ? (isFr ? "AJOUTER L'EXTRAIT" : 'ADD THE EXTRAIT') : (isFr ? 'ÉPUISÉ' : 'SOLD OUT');
  }
}

function translateHomePage(isFr) {
  setText('.kayan-home-hero h1', isFr ? "L'essence du caractère. Le souffle de la grâce." : 'The essence of character. The breath of grace.');
  setText('.kayan-home-hero p', isFr ? 'Deux signatures pour laisser une présence intime, chaude et impossible à oublier.' : 'Two signatures designed to leave an intimate, warm and unforgettable presence.');
  setAllText('.kayan-hero-actions a', isFr ? ['Découvrir la collection', 'Premier Souffle'] : ['Discover the collection', 'Premier Souffle']);
  setAllText('.kayan-showcase-card strong', isFr ? ["Acheter l'extrait", 'Découvrir la brume', "Lire l'histoire"] : ['Shop the extrait', 'Discover the mist', 'Read the story']);
  setText('.kayan-editorial h2', isFr ? 'Un extrait pour signer. Une brume pour raviver.' : 'An extrait to sign. A mist to revive.');
  setText('.kayan-editorial a', isFr ? 'Composer mon rituel' : 'Build my ritual');
}

function translateCartPage(isFr) {
  setText('.kayan-cart-heading .kayan-kicker', isFr ? 'PANIER' : 'SHOPPING CART');
  setText('.kayan-cart-heading h1', isFr ? 'Votre sélection' : 'Your selection');
  setText('.kayan-cart-empty p', isFr ? 'Votre panier est vide.' : 'Your cart is empty.');
  setText('.kayan-cart-empty a', isFr ? 'Découvrir la collection' : 'Discover the collection');
  setText('.kayan-cart-summary h2', isFr ? 'Résumé' : 'Summary');
  setText('.kayan-cart-summary div span', isFr ? 'Sous-total' : 'Subtotal');
  setText('.kayan-cart-summary p', isFr ? 'Livraison, taxes et remises sont calculées au paiement.' : 'Shipping, taxes and discounts are calculated at checkout.');
  setText('.kayan-cart-update', isFr ? 'Mettre à jour' : 'Update cart');
  setText('.kayan-cart-checkout', isFr ? 'Passer au paiement' : 'Checkout');
  setText('.kayan-cart-continue', isFr ? 'Continuer mes achats' : 'Continue shopping');
  setAllText('.kayan-cart-item__quantity label', Array.from(document.querySelectorAll('.kayan-cart-item__quantity label')).map(() => (isFr ? 'Quantité' : 'Quantity')));
  setAllText('.kayan-cart-item__quantity a', Array.from(document.querySelectorAll('.kayan-cart-item__quantity a')).map(() => (isFr ? 'Retirer' : 'Remove')));
}
